import moment from "moment-timezone"

export const currentDateInUnix = () => {
	return moment().tz("Asia/Dhaka").startOf("day").unix()
}